import React, { Component } from "react";
import axios from "axios";

import Nav from "../components/Nav";
import Sidebar from "../components/Sidebar";
import "../styles/parkingInfo.css";
import capacityIcon from "../images/location.png";
import occupiedIcon from "../images/parking.png";
import reservationFeeIcon from "../images/garage.png";
import hourlyRateIcon from "../images/cash.png";
import firebase from "firebase";
import { Link } from "react-router-dom";
import Loading from "../components/LoadingPage";

//redux
import { connect } from "react-redux";

//font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

class parkingInfo extends Component {
  state = {
    loggedParkingInfo: {},
    capacity: 0,
    occupiedSlots: 0,
    carsInsideTheFacility: 0,
    loading: true
  };

  componentDidMount() {
    const db = firebase.firestore();

    let date = new Date();
    let formattedDate = date
      .toLocaleDateString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      })
      .split("/")
      .join("-");

    console.log(formattedDate);

    db.collection("parking")
      .doc("parking_users")
      .collection(formattedDate)
      .where("exitDateTime", "==", "")
      .onSnapshot(querySnapshot => {
        this.setState({
          carsInsideTheFacility: querySnapshot.size,
          loading: false
        });
      });

    db.collection("parking_status").onSnapshot(querySnapshot => {
      let occupiedSlots = 0;
      let reservedSlots = 0;

      this.setState({ capacity: querySnapshot.size, loading: false });

      querySnapshot.docs.map(parking => {
        if (parking.data().status === "Occupied") {
          occupiedSlots++;
        } else if (parking.data().status === "Reserved") {
          reservedSlots++;
        }

        this.setState({
          occupiedSlots: occupiedSlots,
          reservedSlots: reservedSlots,
          loading: false
        });
        return 0;
      });
    });

    db.collection("parking")
      .doc("information")
      .onSnapshot(doc => {
        this.setState({
          loggedParkingInfo: doc.data(),
          loading: false
        });
        return 0;
      });
  }

  handleChange = e => {
    this.setState({
      loggedParkingInfo: {
        ...this.state.loggedParkingInfo,
        [e.target.name]: e.target.value
      }
    });
  };

  editButtonHandler = () => {
    this.setState({ isEditButtonClicked: true });
  };

  saveButtonHandler = async () => {
    const { loggedParkingInfo } = this.state;
    try {
      await axios
        .post("/parking/details/edit", loggedParkingInfo)
        .then(res => console.log(res.data.message));
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { loggedParkingInfo } = this.state;
    const { user } = this.props;
    const divClassname =
      this.props.user.role === "admin"
        ? "col-md-8 col-lg-10 p-0"
        : "col-md-8 col-lg-12 p-0";
    return (
      <div>
        {this.state.loading ? (
          <Loading />
        ) : (
            <div>
              <Nav />
              <div class="row content-div">
                {user.role === "admin" && (
                  <div class="col-md-2 d-md-block sidebar">
                    <Sidebar />
                  </div>
                )}

                <div className={divClassname}>
                  <div className="container-fluid">
                    <div className="d-sm-flex align-items-center justify-content-between m-4 shadow-sm p-3 mb-5 bg-white rounded">
                      <h1 className="h3 text-gray-800">
                        Welome back, Development Team!
                    </h1>
                    </div>

                    <div className="card m-5">
                      <div className="card-header">
                        <h6 className="d-inline-block align-middle mb-0 mt-2">
                          Parking Information
                      </h6>
                        <div className="card-tools float-right d-inline-block align-middle">
                          <Link
                            type="button"
                            className="btn btn-tool"
                            to="/editParkingInfo"
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </Link>
                        </div>
                      </div>
                      <div className="row justify-content-md-center p-4">
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4 infoDiv">
                          <img
                            src={capacityIcon}
                            className="capacityIcon mr-2"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">
                              {this.state.capacity}
                            </p>
                            <p> CAPACITY</p>
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4  infoDiv">
                          <img
                            src={occupiedIcon}
                            className="capacityIcon mr-3"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">
                              {this.state.capacity -
                                this.state.carsInsideTheFacility}
                            </p>
                            <p> AVAILABLE</p>
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4 infoDiv">
                          <img
                            src={reservationFeeIcon}
                            className="capacityIcon mr-3"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">
                              {this.state.occupiedSlots}
                            </p>
                            <p>OCCUPIED</p>
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4 infoDiv">
                          <img
                            src={hourlyRateIcon}
                            className="capacityIcon mr-3"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">
                              {this.state.reservedSlots}
                            </p>
                            <p> RESERVED</p>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-md-center p-4">
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4 infoDiv">
                          <img
                            src={capacityIcon}
                            className="capacityIcon mr-2"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">
                              {loggedParkingInfo.hourlyRate}
                            </p>
                            <p> PRICE</p>
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4  infoDiv">
                          <img
                            src={occupiedIcon}
                            className="capacityIcon mr-3"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">
                              {loggedParkingInfo.reservationFee}
                            </p>
                            <p> RESERVATION FEE</p>
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4 infoDiv">
                          <img
                            src={reservationFeeIcon}
                            className="capacityIcon mr-3"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">500</p>
                            <p> OVERNIGHT FEE</p>
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-6 m-4 pt-4 pb-4 infoDiv">
                          <img
                            src={hourlyRateIcon}
                            className="capacityIcon mr-3"
                            alt=""
                          />
                          <div className="d-inline-block align-middle">
                            <p className="h1 display-4 mt-3">
                              {loggedParkingInfo.isFixed === "true"
                                ? "YES"
                                : "NO"}
                            </p>
                            <p> RATE IS FIXED</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(parkingInfo);
